module.exports = __webpack_public_path__ + "media/images/league-2-9d9b9c6b0cd334a111096a2240ec4151.png";